// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3654ccda","37":"c65643d5","299":"468b45a4","644":"31fc89f6","693":"dcdb1b7a","713":"2882aa3f","837":"19e64c6f","930":"062d44e4"}[chunkId] + ".chunk.js";
};